module.exports = __webpack_public_path__ + "static/img/irole.65acaad.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/kc/irole.png
// module id = K+J0
// module chunks = 7